import React, {useContext, useRef, useState} from 'react';
import moment from "moment";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import SystemContext from "../../../SystemContext";
import { useTheme } from '@material-ui/core';


const TripConfirmation = (props) => {
  const SystemData = useContext(SystemContext);
  const theme = useTheme();
  const dialogTitle = props.object + " for Trip " + props.trip;
  const confirmationObject = (props.object ? props.object.replace("Confirm", "") : "");
  const confirmationAction = props.requiredConfirmation;

  function handleClose() {
    props.onChange(null);
  }

  function handleUpdate() {
    if(props && props.object) {
      const confirmation = {
        object: props.object,
        confirmedBy: props.user,
        confirmationDate: moment().format("YYYY-MM-DD HH:mm")
      }
      props.onChange(confirmation);
    }
    else
      props.onChange(null);
  }

  return (
    <div id={"TripConfirmation"}>
      <Dialog open={props.open}
              onClose={handleClose}
              aria-labelledby="form-dialog-title"
              disableBackdropClick={true}
              maxWidth={"md"}
              fullWidth={true}
      >
        <DialogTitle id="form-dialog-title">
          <div style={{clear: "both", backgroundColor:theme.palette.primary.main, padding:"10px"}}>
          {dialogTitle}
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Click <strong>Confirm</strong> to record that <strong>{confirmationAction}</strong> action of <strong>{confirmationObject}</strong> for trip <strong>{props.trip}</strong> was completed by <strong>{props.user}</strong>
          </DialogContentText>

        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleUpdate} color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default TripConfirmation;